module.exports = __webpack_public_path__ + "static/media/一种基于人脸识别的身份对比核查装置.8e0e940c.png";